module.exports = __webpack_public_path__ + "static/media/angry1.89c29e70.svg";